import React from 'react';
import styled from 'styled-components';
import { ITranslations } from '../../interfaces/ITranslationFields';
import withTranslations from '../../hocs/withTranslations';
import StyledLinkLabel from '../StyledLinkLabel/StyledLinkLabel';
import { MinusIcon, PlusIcon } from '@estee/elc-icons';

interface IShoppingBagHeaderProps {
  translations?: ITranslations;
  title: string;
  itemsCount: number;
  toggleShoppingBagOpen?(e: React.SyntheticEvent): void;
  cartUrl: string;
  isCollapsed?: boolean;
  locale: string;
}

const ShoppingBagHeadingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ShoppingBagHeaderLabel = styled.h2`
  font-size: 15px;
  letter-spacing: 0.15px;
  position: relative;
`;

const ShoppingBagBtn = styled.button`
  border: none;
  padding: 0;
`;

const HeaderIconWrapper = styled.div`
  display: flex;
  width: auto;
  justify-content: space-between;
`;

export const ShoppingBagBtnWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const EditShoppingBag = styled.a`
  text-decoration: none;
  margin-right: 24px;
  text-transform: capitalize;
`;

export const ToggleBtn = styled.button`
  border: none;
  padding: 0;
`;

class ShoppingBagHeader extends React.Component<IShoppingBagHeaderProps> {
  render(): JSX.Element {
    const {
      title,
      itemsCount,
      toggleShoppingBagOpen,
      translations: { editCart },
      cartUrl,
      isCollapsed,
    } = this.props;

    return (
      <ShoppingBagHeadingWrapper>
        <ShoppingBagBtn
          onClick={toggleShoppingBagOpen}
          className="acac-shopping-bag-toggle-btn"
          aria-expanded
        >
          <ShoppingBagHeaderLabel
            className="acac-shopping-bag-header"
            data-test-id="dp_label_shopping_bag"
          >
            {title} ({itemsCount})
          </ShoppingBagHeaderLabel>
        </ShoppingBagBtn>
        <ShoppingBagBtnWrapper data-test-id="dp_label_shopping_bag_btn-wrapper">
          {!isCollapsed && (
            <EditShoppingBag href={cartUrl}>
              <StyledLinkLabel className="elc-button elc-button--text edit-bag-btn">
                {editCart}
              </StyledLinkLabel>
            </EditShoppingBag>
          )}
          <HeaderIconWrapper>
            <ToggleBtn
              onClick={toggleShoppingBagOpen}
              className="acac-shopping-bag-toggle-btn"
              aria-expanded
              aria-label={title}
            >
              {isCollapsed ? <PlusIcon /> : <MinusIcon />}
            </ToggleBtn>
          </HeaderIconWrapper>
        </ShoppingBagBtnWrapper>
      </ShoppingBagHeadingWrapper>
    );
  }
}

export default withTranslations(ShoppingBagHeader);
